/**
 * Copyright © 2018 Galaxy Software Services https://github.com/GSS-FED/vital-ui-kit-react
 * MIT license
 */
import * as React from 'react';
var SubListItem = function (_a) {
    var children = _a.children, level = _a.level, isChildren = _a.isChildren, themed = _a.themed;
    var renderChildren = function () {
        return React.Children.map(children, function (child) {
            return React.cloneElement(child, {
                level: level,
                isChildren: isChildren,
                themed: themed,
            });
        });
    };
    return React.createElement(React.Fragment, null, renderChildren());
};
export default SubListItem;
//# sourceMappingURL=SubListItem.js.map